// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3exQR","question":"styles_question__3JmsJ","inputVisibleButton":"styles_inputVisibleButton__2tOqm","note":"styles_note__341Bs"};